<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1"><div id="_idContainer009">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
<p class="noindent">A PERMUTED PRESS BOOK</p>
<p class="noindent">ISBN: 978-1-68261-702-1</p>
<p class="noindent">ISBN (eBook): 978-1-68261-895-0</p>
<p class="noindent">Midnight Sun</p>
<p class="noindent">© 2019 by Basil Sands</p>
<p class="noindent">All Rights Reserved</p>
<p class="noindent">Cover art by Christian Bentulan</p>
<p class="noindent">This book is a work of fiction. People, places, events, and situations are the product of the author’s imagination. Any resemblance to actual persons, living or dead, or historical events, is <span class="no-break">purely coincidental.</span></p>
<p class="noindent">No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means without the written permission of the author <span class="no-break">and publisher.</span></p>
<p class="noindent"><img alt="" class="_idGenObjectAttribute-4" src="Images/pp_v_dark1.png"/></p>
<p class="noindent">Permuted Press, LLC</p>
<p class="noindent">New York • Nashville</p>
<p class="noindent">permutedpress.com</p>
<p class="noindent">Published in the United States of America</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0044.vue?4ba38c70